// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xHAtj{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;padding:24px;gap:8px}.xHAtj.q3szi{padding:16px;gap:12px}.lvrJE{width:100%;max-width:800px;display:flex;align-items:center;justify-content:center;min-height:0}.DoqZM{position:relative;width:100%;aspect-ratio:16/9;max-height:100%;border-radius:12px;overflow:hidden}.xaGz3{position:absolute;inset:0;width:100%;height:100%;border:none}.SXeHO{display:flex;align-items:center;gap:12px;width:100%;max-width:800px;flex-shrink:0}.phavo{flex:1;height:4px;background:var(--color-dark-200);border-radius:2px;overflow:hidden}.zaK4I{height:100%;border-radius:2px;background:linear-gradient(90deg, #2cf1ff 0%, #967bfb 50%, #ff7aaa 100%);transition:width .1s linear}.I48ge{width:40px;height:40px;display:flex;align-items:center;justify-content:center;flex-shrink:0;color:var(--color-purple-800)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `xHAtj`,
	"mobile": `q3szi`,
	"videoWrapper": `lvrJE`,
	"videoContainer": `DoqZM`,
	"iframe": `xaGz3`,
	"controls": `SXeHO`,
	"progressTrack": `phavo`,
	"progressFill": `zaK4I`,
	"giftIcon": `I48ge`
};
export default ___CSS_LOADER_EXPORT___;
